export class TimeoutConfig {
    timeout?: number;
    idle?: number;
}
